import type { LoadingStatus } from "../ViewJobLoadingState";

/**
 * Combines ViewJob's two parallel query statuses into the page-level network status.
 *
 * A viewjob error is critical; a jobDataResult error is not, because only
 * `matchComparison` comes from that query and the rest of the page renders fine without
 * it (WENG-2085). Likewise an in-flight jobDataResult must not pull an already-succeeded
 * viewjob back to `"active"` -- on an SSR'd page that would discard the server-rendered
 * content for one round trip (RN-8338).
 *
 * This reports the network only. Whether there is content to show outranks it, and that
 * is decided once, at the render gate (`contentStatus` in `AppContentGraphQL`).
 */
export function resolveViewJobQueryStatus({
  viewJobQueryStatus,
  jobDataResultQueryStatus,
}: {
  viewJobQueryStatus: LoadingStatus;
  jobDataResultQueryStatus: LoadingStatus;
}): LoadingStatus {
  if (viewJobQueryStatus === "success") return "success";
  if (viewJobQueryStatus === "active" || jobDataResultQueryStatus === "active") return "active";
  if (viewJobQueryStatus === "error") return "error";
  return "idle";
}
